<template>
  <div class="teach-activity-info">
    <div class="teaching-dynamics-box">
        <div class="teaching-dynamics-item">
            <div class="number">165</div>
            <div class="name">教研活动数</div>
        </div>
        <div class="teaching-dynamics-line"></div>
        <div class="teaching-dynamics-item">
            <div class="number">65</div>
            <div class="name">备课活动数</div>
        </div>
        <div class="teaching-dynamics-line"></div>
        <div class="teaching-dynamics-item">
            <div class="number">562</div>
            <div class="name">备课资源数</div>
        </div>
        <div class="teaching-dynamics-line"></div>
        <div class="teaching-dynamics-item">
            <div class="number">126</div>
            <div class="name">听评课活动数</div>
        </div>
        <div class="teaching-dynamics-line"></div>
        <div class="teaching-dynamics-item">
            <div class="number">1254</div>
            <div class="name">研讨次数</div>
        </div>
    </div>
    <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
    <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
  </div>
</template>
<script>
export default {
  name: 'teach-activity-info',
  data() {
    return {

    }
  },
  methods: {

  },
  mounted(){

  }
}
</script>
<style lang='scss' scoped>
.teach-activity-info{
    width: 100%;
    height: 95px;
    margin-bottom: 5px;
    position: relative;
    .teaching-dynamics-box{
            width: 100%;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: space-around;
            .teaching-dynamics-item{
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                .number{
                    font-size: 36px;
                    font-family: DigifaceWide;
                    font-weight: 400;
                    color: #38FFF3;
                }
                .name{
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #6EA0D3;
                }
            }
            .teaching-dynamics-line{
                width: 1px;
                height: 50px;
                background: linear-gradient(0deg, #0D1A47 0%, #1C5DBB 56.99999999999999%, #0D1A47 100%);
                border-radius: 1px;
            }
        }

    .top-left{
        position: absolute;
        top: 0;
        left: 0;
        width: 14px;
        height: 14px;
    }
    .right-bottom{
        position: absolute;
        bottom: 0;
        right: 0;
        width: 14px;
        height: 14px;
    }
}
</style>